export const raChineseMessages = {
  ra: {
    action: {
      add_filter: "添加筛选条件",
      add: "添加",
      back: "返回",
      bulk_actions: "已选择 1 项 |||| 已选择 %{smart_count} 项",
      cancel: "取消",
      clear_array_input: "清空列表",
      clear_input_value: "清除值",
      clone: "克隆",
      confirm: "确认",
      create: "新建",
      create_item: "新建 %{item}",
      delete: "删除",
      edit: "编辑",
      export: "导出",
      list: "列表",
      refresh: "刷新",
      remove_filter: "移除此筛选条件",
      remove_all_filters: "移除所有筛选条件",
      remove: "移除",
      reset: "重置",
      save: "保存",
      search: "搜索",
      search_columns: "搜索列",
      select_all: "全选",
      select_all_button: "全选",
      select_row: "选择此行",
      show: "查看",
      sort: "排序",
      undo: "撤销",
      unselect: "取消选择",
      expand: "展开",
      close: "关闭",
      open_menu: "打开菜单",
      close_menu: "关闭菜单",
      update: "更新",
      move_up: "上移",
      move_down: "下移",
      open: "打开",
      toggle_theme: "切换浅色/深色模式",
      select_columns: "列",
      update_application: "重新加载应用",
    },
    boolean: {
      true: "是",
      false: "否",
      null: " ",
    },
    page: {
      create: "新建 %{name}",
      dashboard: "仪表盘",
      edit: "%{name} %{recordRepresentation}",
      error: "出现错误",
      list: "%{name}",
      loading: "加载中",
      not_found: "页面未找到",
      show: "%{name} %{recordRepresentation}",
      empty: "暂无 %{name}。",
      invite: "是否要添加一个？",
      access_denied: "访问被拒绝",
      authentication_error: "认证错误",
    },
    input: {
      file: {
        upload_several: "拖放文件到此处上传，或点击选择文件。",
        upload_single: "拖放文件到此处上传，或点击选择文件。",
      },
      image: {
        upload_several: "拖放图片到此处上传，或点击选择图片。",
        upload_single: "拖放图片到此处上传，或点击选择图片。",
      },
      references: {
        all_missing: "无法找到引用数据。",
        many_missing: "至少有一条关联引用已不再可用。",
        single_missing: "关联引用已不再可用。",
      },
      password: {
        toggle_visible: "隐藏密码",
        toggle_hidden: "显示密码",
      },
    },
    message: {
      about: "关于",
      access_denied: "您没有访问此页面的权限",
      are_you_sure: "确定要执行此操作吗？",
      authentication_error: "认证服务器返回错误，无法验证您的凭据。",
      auth_error: "验证认证令牌时发生错误。",
      bulk_delete_content:
        "确定要删除此 %{name} 吗？ |||| 确定要删除这 %{smart_count} 项吗？",
      bulk_delete_title: "删除 %{name} |||| 删除 %{smart_count} 个 %{name}",
      bulk_update_content:
        "确定要更新 %{name} %{recordRepresentation} 吗？ |||| 确定要更新这 %{smart_count} 项吗？",
      bulk_update_title:
        "更新 %{name} %{recordRepresentation} |||| 更新 %{smart_count} 个 %{name}",
      clear_array_input: "确定要清空整个列表吗？",
      delete_content: "确定要删除此 %{name} 吗？",
      delete_title: "删除 %{name} %{recordRepresentation}",
      details: "详情",
      error: "发生客户端错误，请求未能完成。",
      invalid_form: "表单验证未通过，请检查错误信息",
      loading: "请稍候",
      no: "否",
      not_found: "您输入了错误的 URL，或者点击了无效的链接。",
      select_all_limit_reached:
        "元素数量过多，无法全部选中。仅选中了前 %{max} 个元素。",
      unsaved_changes: "部分更改尚未保存。确定要放弃这些更改吗？",
      yes: "是",
      placeholder_data_warning: "网络异常：数据刷新失败。",
    },
    navigation: {
      clear_filters: "清除筛选条件",
      no_filtered_results: "使用当前筛选条件未找到 %{name}。",
      no_results: "未找到 %{name}",
      no_more_results: "页码 %{page} 超出范围，请尝试上一页。",
      page_out_of_boundaries: "页码 %{page} 超出范围",
      page_out_from_end: "已到最后一页",
      page_out_from_begin: "已到第一页",
      page_range_info: "%{offsetBegin}-%{offsetEnd} / 共 %{total} 条",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} / 超过 %{offsetEnd} 条",
      current_page: "第 %{page} 页",
      page: "跳转到第 %{page} 页",
      first: "跳转到第一页",
      last: "跳转到最后一页",
      next: "下一页",
      previous: "上一页",
      page_rows_per_page: "每页行数：",
      skip_nav: "跳转到内容",
    },
    sort: {
      sort_by: "按 %{field_lower_first} %{order}排序",
      ASC: "升序",
      DESC: "降序",
    },
    auth: {
      auth_check_error: "请登录后继续",
      user_menu: "个人资料",
      username: "用户名",
      password: "密码",
      email: "邮箱",
      sign_in: "登录",
      sign_in_error: "认证失败，请重试",
      logout: "退出登录",
    },
    notification: {
      updated: "记录已更新 |||| %{smart_count} 条记录已更新",
      created: "记录已创建",
      deleted: "记录已删除 |||| %{smart_count} 条记录已删除",
      bad_item: "记录格式不正确",
      item_doesnt_exist: "记录不存在",
      http_error: "服务器通信错误",
      data_provider_error: "数据提供程序错误，请查看控制台获取详情。",
      i18n_error: "无法加载指定语言的翻译文件",
      canceled: "操作已取消",
      logged_out: "您的会话已结束，请重新登录。",
      not_authorized: "您无权访问此资源。",
      application_update_available: "有新版本可用。",
      offline: "无网络连接，无法获取数据。",
    },
    validation: {
      required: "必填",
      minLength: "最少需要 %{min} 个字符",
      maxLength: "最多不超过 %{max} 个字符",
      minValue: "最小值为 %{min}",
      maxValue: "最大值为 %{max}",
      number: "必须为数字",
      email: "必须为有效的邮箱地址",
      oneOf: "必须为以下之一：%{options}",
      regex: "必须匹配指定格式（正则表达式）：%{pattern}",
      unique: "必须唯一",
    },
    saved_queries: {
      label: "已保存的查询",
      query_name: "查询名称",
      new_label: "保存当前查询...",
      new_dialog_title: "将当前查询保存为",
      remove_label: "移除已保存的查询",
      remove_label_with_name: '移除查询 "%{name}"',
      remove_dialog_title: "移除已保存的查询？",
      remove_message: "确定要从已保存的查询列表中移除此项吗？",
      help: "筛选列表并保存此查询以便稍后使用",
    },
    configurable: {
      customize: "自定义",
      configureMode: "配置此页面",
      inspector: {
        title: "检查器",
        content: "将鼠标悬停在应用界面元素上以进行配置",
        reset: "重置设置",
        hideAll: "全部隐藏",
        showAll: "全部显示",
      },
      Datagrid: {
        title: "数据表格",
        unlabeled: "未命名列 #%{column}",
      },
      SimpleForm: {
        title: "表单",
        unlabeled: "未命名输入框 #%{input}",
      },
      SimpleList: {
        title: "列表",
        primaryText: "主要文本",
        secondaryText: "次要文本",
        tertiaryText: "附加文本",
      },
    },
  },
};
